import './Home.css';
import '../App.css'
import Button from './button'

import React, { useState, useEffect } from "react";
import usama from '../assets/usama.jpeg'
// import man from "./../images/man.svg";
import { motion, AnimatePresence } from "framer-motion";
// import { animateScroll as scroll } from "react-scroll";

const contentVariants = {
  initial: {
    translateY: "100vh",
    opacity: 0,
  },

  animate: {
    translateY: "0vh",
    opacity: 1,
    transition: {
      duration: 2,
      when: "beforeChildren",
      // staggerChildren: 0.4,
    },
  },
};

const childrenVariants = {
  initial: {
    opacity: 0,
    y: 100,
  },

  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      type: "spring",
      delay: 0.5,
    },
  },

  exit: {
    opacity: 0,
    y: -200,
    transition: { duration: 0.2 },
  },
};

const Home = () => {
  // State
  const [showHeadingOne, setShowHeadingOne] = useState(true);
  const [showHeadingTwo, setShowHeadingTwo] = useState(false);


  // Timeout
  useEffect(() => {
    setTimeout(() => {
      if (showHeadingOne) {
        setShowHeadingOne(false);
        setShowHeadingTwo(true);
     
      } else  {
        setShowHeadingOne(true);
        setShowHeadingTwo(false);
      }
    }, 3000);
  }, [showHeadingOne, showHeadingTwo]);

  return (
    <section className="home-container" id="home" name="home">
      <motion.div
        className="content-container"
        variants={contentVariants}
        initial="initial"
        animate="animate"
      >
        <h2 className="welcome-content">Hello World</h2>
  
        <br />
        <h1 className="main-content name">
         <p className="hi">Hi,</p>
          I’m Syed Usama Ali
          {/* <motion.span
            drag={true}
            dragConstraints={{ left: 0, top: 0, bottom: 0, right: 0 }}
            className="hand"
            animate={{ rotate: [0, 20, 0, 20, 0, 0, 0, 0, 0, 0] }}
            transition={{ yoyo: Infinity, duration: 1.7 }}
          >
            <span role="img" aria-label="Hand waving">
              👋
            </span>
          </motion.span>{" "} */}
        </h1>
        {/* Animate Skill Content */}

        <div className="skill-animation">
          <AnimatePresence>
            {showHeadingOne && (
              <motion.h2
                className="skill-content"
                variants={childrenVariants}
                exit="exit"
                animate="animate"
                initial="initial"
              >
               Web Designer | web Developer
              </motion.h2>
            )}
          </AnimatePresence>

          <AnimatePresence>
            {showHeadingTwo && (
              <motion.h2
                className="skill-content chng"
                variants={childrenVariants}
                exit="exit"
                animate="animate"
                initial="initial"
              >
                React | React Native Developer
              </motion.h2>
            )}
          </AnimatePresence>

          {/* <AnimatePresence>
            {showHeadingThree && (
              <motion.h2
                className="skill-content"
                variants={childrenVariants}
                exit="exit"
                animate="animate"
                initial="initial"
              >
                Open Source Contributor | Free Lancer
              </motion.h2>
             )} 
          </AnimatePresence> */}
        </div>
        {/* // */}
<br></br>
        <h1 className="pk">
          {" "}
          Pakistani{"  "}
          <span role="img" aria-label="Pakistan Flag">
            🇵🇰
          </span>
        </h1>
        <br></br>
          <div className="flexx">
          {/* <button className="button" onClick={() => scroll.scrollToBottom()}>
          Contact Me
        </button> */}
        <br></br>
        <Button></Button>
          </div>
      
     

     
      </motion.div>
    
      <motion.div
        className="svg-container"
        animate={{ translateY: [-20, 0, -20, 0] }}
        transition={{ yoyo: Infinity, duration: 6 }}
      >
        <img className="svg" src={usama} alt="" />
     
      </motion.div>

    
    </section>
  );
};

export default Home;
